var render, staticRenderFns
import script from "./UIButton.vue?vue&type=script&lang=js&"
export * from "./UIButton.vue?vue&type=script&lang=js&"
import style0 from "./UIButton.vue?vue&type=style&index=0&id=727f6dd1&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727f6dd1",
  null
  
)

export default component.exports